import dayjs from "dayjs";

export const handleDateChange = (
    dateValue: string,
    name: string,
    setValues: any,
    currentDateFormat:string
  ) => {
    setValues((preVals: any) => ({
      ...preVals,
      [name]: dayjs(dateValue, currentDateFormat).isValid() ? dayjs(dateValue, currentDateFormat) : undefined,
    }));
  };
